import { LabCanvas3D } from './LabCanvas3D';
import { type TitrationSceneState, createTitrationScene } from './titrationScene';

export type { TitrationSceneState } from './titrationScene';

/**
 * Real-world view of a titration: a burette whose level falls as titrant is delivered, above a
 * conical flask whose volume and indicator colour follow the same model state.
 */
export function Titration3D({ state, playing, label }: { state: TitrationSceneState; playing: boolean; label: string }) {
  return <LabCanvas3D build={createTitrationScene} state={state} playing={playing} label={label} hint="Drag to turn the bench" heightClass="h-[440px] lg:h-[560px]" />;
}
